import { useCallback, useEffect, useState } from 'react';
import {
  preRequest,
  resetPreRequest,
  selectPreRequest,
} from '@pharmaplan/common';
import { stub } from '@pharmaplan/common/helpers/utils';
import { useAppSelector } from '../useAppSelector';
import { useAppDispatch } from '../useAppDispatch';
import usePreRequestUtils from './usePreRequestUtils';

const usePreRequestLongTerm = () => {
  const dispatch = useAppDispatch();

  const [params, setParams] = useState({
    id: '',
    callback:
      stub,
  });

  const { id } = params ?? {};

  const preRequestStatus = useAppSelector(selectPreRequest);
  const { isSufficientSoftwareKnowledge } = preRequestStatus ?? {};

  const { showSoftwareWarning } = usePreRequestUtils();

  const runSoftwareCheck = useCallback(() => {
    if (id) {
      if (isSufficientSoftwareKnowledge === false) {
        showSoftwareWarning();
      } else if (isSufficientSoftwareKnowledge === true) {
        params?.callback();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSufficientSoftwareKnowledge]);

  useEffect(() => {
    runSoftwareCheck();
    dispatch(resetPreRequest());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSufficientSoftwareKnowledge]);

  const preRequestBooking = (
    workshiftId: string,
    successCallback: () => void,
    _isAutoSyncRecord?: boolean,
  ) => {
    setParams({
      id: workshiftId,
      callback: successCallback,
    });

    dispatch(
      preRequest({
        workshiftid: workshiftId,
        isAutoSyncRecord: _isAutoSyncRecord,
      }),
    );
  };

  return { preRequestBooking };
};

export default usePreRequestLongTerm;
